import {Component, EventEmitter, Inject, Injector, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BaseComponentDirective} from "../../../_shared/base/base.component";
import {ProviderService} from "../../../_services/provider.service";
import {ConfirmationDialog} from "../../../_shared/dialog/confirmation.dialog";
import {AdminService} from "../../dashboard/services/admin.service";
import {CertService} from "../../dashboard/services/cert.service";
import {MatSelectChange} from "@angular/material/select";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";
import {AddProviderDialog} from "./add-provider.dialog";
import {isMoment} from "moment";

@Component({
    selector: 'admin-training-modal',
    templateUrl: './admin-add-new-training.dialog.html',
    styleUrls: ['../../../scss/office.scss'],

})
export class AdminAddNewTrainingDialog extends BaseComponentDirective implements OnInit {
    public result = new EventEmitter();
    public form: FormGroup;
    public providers: any[] = [];
    ceTypeParams: any = {};
    attendanceTypeParams: any = {};
    published = 'Published';
    certs: any[] = [];
    constructor(
        injector: Injector,
        public dialogRef: MatDialogRef<AdminAddNewTrainingDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private formBuilder: FormBuilder,
        private providerService: ProviderService,
        private adminService: AdminService,
        private certService: CertService
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            title: [null, [Validators.required]],
            provider: [null, [Validators.required]],
            certificationId: [null, []],
            city: [null, [Validators.required]],
            state: [null, [Validators.required]],
            zipcode: [null, [Validators.required]],
            startDate: [null, [Validators.required]],
            endDate: [null, [Validators.required]],
            attendanceType: [null, [Validators.required]],
            ceType: [null, [Validators.required]],
            cost: [null, [Validators.required]],
            active: [true]
        });
    }

    override async ngOnInit(): Promise<any> {
        this.providers = await this.providerService.getAllProvider();


        this.ceTypeParams = this.data.ceTypes;
        this.attendanceTypeParams = this.data.attendanceTypes;

        if (this.data.mode == 'edit') {
            this.form.controls.title.setValue(this.data.ceu.title);
            this.form.controls.provider.setValue(this.data.ceu?.association?.id);
            this.form.controls.certificationId.setValue(this.data.ceu?.certification?.id);
            this.certs = await this.certService.getCertificationByProvider(this.data.ceu?.association?.id);

            this.form.controls.city.setValue(this.data.ceu.city);
            this.form.controls.state.setValue(this.data.ceu.stateOrProvince);
            this.form.controls.zipcode.setValue(this.data.ceu.postalCode);

            this.form.controls.startDate.setValue(this.data.ceu.startDate);
            this.form.controls.endDate.setValue(this.data.ceu.endDate);

            this.form.controls.attendanceType.setValue(this.data.ceu.attendanceType);
            this.form.controls.ceType.setValue(this.data.ceu.ceType);

            this.form.controls.cost.setValue(this.data.ceu.cost);
            this.form.controls.active.setValue(this.data.ceu.active);
            this.published = this.data.ceu.active ? 'Published' : 'Unpublished';
        }
    }

    save() {

        const validation = this.check(this.form);
        if(validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                message: '',
                subMessage: (this.data.mode == 'new')? 'Are you sure want to save new training?':'Are you sure want to update this training?',
                buttonOkLabel: 'Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        dialog.componentInstance.result.subscribe(r => {
            if(r) {

                let p = this.providers.find(p => p.id == this.form.controls.provider.value);

                let payload:any = {
                    title: this.form.controls.title.value,
                    provider: p.providerName,
                    providerId: this.form.controls.provider.value,
                    certificationId: this.form.controls.certificationId.value,
                    city: this.form.controls.city.value,
                    state: this.form.controls.state.value,
                    zipcode: this.form.controls.zipcode.value,
                    startDate: isMoment(this.form.controls.startDate.value)? this.date.momentToDbDate(this.form.controls.startDate.value):this.form.controls.startDate.value,
                    endDate: isMoment(this.form.controls.endDate.value)? this.date.momentToDbDate(this.form.controls.endDate.value):this.form.controls.endDate.value,
                    attendanceType: this.form.controls.attendanceType.value,
                    ceType: this.form.controls.ceType.value,
                    cost: this.form.controls.cost.value,
                    active: this.form.controls.active.value
                }

                if(this.data.mode == 'new') {
                    this.adminService.addNewCeuEvent(payload).then(_ => {
                        this.result.emit(true);
                        this.form.reset();
                        this.form.markAsPristine();
                        this.form.markAsUntouched();
                        this.showAlertDark('Training', '', 'Training has been addeds successfully!');
                        this.closeDialog();
                    })
                } else {
                    payload['id'] = this.data.ceu.id;
                    this.adminService.editCeuEvent(payload).then(_ => {
                        this.result.emit(true);
                        this.form.reset();
                        this.form.markAsPristine();
                        this.form.markAsUntouched();
                        this.showAlertDark('Training', '', 'Training has been updated successfully!');
                        this.closeDialog();
                    })
                }


            } else {
                this.closeDialog();
            }

            this.result.emit(true);
        })
    }

    async onProviderChanged(e: MatSelectChange) {
        this.certs = await this.certService.getCertificationByProvider(e.value);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    resetForm() {
        this.form.reset();
    }

    onActiveChange(e: MatSlideToggleChange) {
        this.published = e.checked ? 'Published' : 'Unpublished';
    }
}
